import { Observable } from 'rxjs'
import { CommissionLevelGateway } from './commission-level-gateway'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'

@Injectable()
export class NetworkCommissionLevelGateway extends CommissionLevelGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getAllCommissionLevel(filter: string): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetCommissionLevel/' + filter
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }
}
